import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {DxDropDownBoxModule,DxFormModule} from 'devextreme-angular';
import {CommonModule} from '@angular/common';
import {UtilsService} from '../../../services/utils.service';
import {ControlConditionModel} from '../../../models/gen-control.model';
import {Observable, Subject, takeUntil} from "rxjs";
import { OrtakService } from '../../../services/ortak.service';
import { GenDropBoxKontrolService } from './ctl-gen-drop-box-kontrol.service';
import { DkDxDataCtlTableComponent } from '../../components';
import { ColumnModel } from '../../../models/dx-data-table.model';
import { DlistDto } from '../../../models/ortak.dtos';
import { DxDropDownBoxTypes } from 'devextreme-angular/ui/drop-down-box';
import { FormLabelMode, LabelLocation } from 'devextreme/ui/form';
import { DkGlobalUserSettingsService  } from '@dabnet-kamu/libs/ui';

@Component({
  selector: 'dk-ctl-gen-drop-box-kontrol',
  standalone: true,
  imports: [
    CommonModule,
    DxDropDownBoxModule,
    DkDxDataCtlTableComponent,
    DxFormModule
  ],
  providers: [GenDropBoxKontrolService],
  templateUrl: './ctl-gen-drop-box-kontrol.component.html',
  styleUrls: ['./ctl-gen-drop-box-kontrol.component.scss'],
})
export class CtlGenDropBoxKontrolComponent implements OnInit, OnChanges {
  private destroyRef = inject(DestroyRef);
  public title!: string;
  public filterColumnValue: any;
  public control!: any;
  public data: any;
  @Input() code: any;
  @Input() period: number;
  @Input() labelText: string = "";
  @Input() labelMode:FormLabelMode = this.globalUserSettingsService.globalLabelMode;
  @Input() notFoundMessage = "Bulunamadı";
  @Input() codeField = "";
  @Input() codeFieldDesc = "";
  @Input() controlName = "";
  @Input() conditionColName: any;
  @Input() conditionColText: any;
  @Input() controlCondition: ControlConditionModel[];
  @Input() isReadOnly = false;
  @Input() type = "string";
  @Input() filterColumn = "";
  @Input() key!: string;
  @Input() validationRulesMap!: any[];
  @Input() validationV2 = false;
  @Input() baseTable = true;
  @Input() customQuery:string = "";
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  private destroy$ = new Subject<void>();
    public columns: ColumnModel[];
      gridControlsList$: Observable<DlistDto>;
      public filterValue:any
      public selectedData: any = null;
      isGridBoxOpened = false;
  constructor(private globalUserSettingsService: DkGlobalUserSettingsService,private service: GenDropBoxKontrolService, private utilsService: UtilsService,
              private ortakService:OrtakService,  private ref: ChangeDetectorRef
  ) {
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    if (this.filterColumnValue) {
      this.filterValue = [this.filterColumn, 'startswith', this.filterColumnValue];
    }
  
    if (this.controlName) {
      this.setParams();
      this.getControl();
    }
  
  }
  displayText = (item: any) => {
      if (!item || !this.control?.descriptionField) return '';

  const fields = this.control.descriptionField
    .split(',')
    .map((f:any) => f.trim());

  const values = fields.map((field:any) => {
    const val = item[field];
    if (!val) return null;

    const date = new Date(val);
    if (!isNaN(date.getTime())) {
      return date.toLocaleDateString('tr-TR'); 
    }

    return val;
  })
  .filter((v:any) => v !== null && v !== undefined && v !== '');

  return values.join(', ');
  };

  setParams() {
    this.service.conditionColName = this.conditionColName;
    this.service.conditionColText = this.conditionColText;
    this.service.controlCondition = this.controlCondition;
    this.service.customQuery = this.customQuery;
  }
  focusChanged(e: any) {
    this.selectedData = e?.row?.data;
  }

  selectedRowData(e:any){
    this.code = [e?.key]
    this.selectedData = e.data;
    this.dataResult.emit(this.selectedData);
    this.isGridBoxOpened = false;
    this.ref.detectChanges();
  }
  onGridBoxOptionChanged(e: DxDropDownBoxTypes.OptionChangedEvent) {
    if (e.name === 'value') {
      this.isGridBoxOpened = false;
      this.ref.detectChanges();
    }
  }

  syncTreeViewSelection(e:any){
    if(e.value === null) this.dataResult.emit(null);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['controlName']) {
      if (this.controlName) {
        this.getControl();
      }
    }
    if (changes && changes['period']) {
      if (this.period) {
        this.service.period = this.period;
      }
    }
    if (changes && (changes['controlCondition'])) {
      this.setParams();
    }
    if (changes && changes['conditionColName'] && changes['conditionColText']) {
      if (this.conditionColName || this.conditionColText) this.setParams();
    }
  }

  getControl() {
    this.ortakService.getControl(this.controlName).pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.control = data?.controlMetadata;
        this.service.getDlist(this.control?.dlistCode);
        this.gridControlsList$ = this.service.gridControlsList$;
  
        this.service.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => {
          this.columns = this.ortakService.setRecursiveFieldData([x], false);
        });
  
        this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata);
  
        if (data?.controlMetadata.dlistMetadata.baseEntity) {
          if (this.labelText === "") this.labelText = this.control.controlDescription;
          if (this.control && !this.data) { 
            this.getData(this.code);
          }
        }
      });
  }
  
  
  
  getData(code: any) {
    if (this.data) {
      return;
    }
    this.data = this.service.getData(this.filterColumn, null, this.control, this.type, this.codeField, this.key);
    if (!this.data) {
      return;
    }
    this.data.load().then((result: any) => {
      if (result?.length > 0 && code) {
        const selectedData = result.find((data: any) => data[this.control.kodField] === code);
        if (selectedData) {
          this.dataResult.emit(selectedData); 
          this.code = selectedData[this.control.kodField]; 
          this.ref.detectChanges();  
        }
      }
    }).catch((error: any) => {
     // console.error("Data yükleme hatası:", error);
    });
  }
  
}

